module.exports = __webpack_public_path__ + "static/media/baart-logo.5df47696.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/baart-logo.svg
// module id = 150
// module chunks = 0